import { useEffect, useState } from 'react';

import { matchSorter } from 'match-sorter';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import PropTypes from 'prop-types';

//lib
import { BoxlabelOptions } from '@/lib/reports/reportOptions';

import Checkbox from '@/components/base/Checkbox';
// Components
import { DefaultSearchBox } from '@/components/composite/SearchBox/DefaultSearchBox';
import HashtagsItem from '@/components/pages/reports/components/Items/Types/HashtagsItem';

const HashtagItemCheckbox = ({ allItems, isSubmitting, checkValue, id, disabled }) => {
    const { t } = useTranslation('commons');

    if (!allItems?.length) {
        {
            BoxlabelOptions(t)[id].empty;
        }
    }
    return allItems.map((item, key) => (
        <div className="flex items-center space-x-3.5" key={key}>
            <HashtagsItem item={item} className="flex-1" />

            <div className="ml-1 pb-2">
                <Checkbox
                    id={item?.id}
                    onChange={() => checkValue(item?.id)}
                    checked={item?.selected ?? false}
                    disabled={isSubmitting || disabled}
                />
            </div>
        </div>
    ));
};

const HashtagItemSearchKey = [{ threshold: matchSorter.rankings.CONTAINS, key: 'name' }];

const SearchBoxHashtag = ({ list, onSetList, errors, isLoading, disabled }) => {
    const { t } = useTranslation();
    const [castData, setCastData] = useState([]);

    useEffect(() => {
        let newList = [];
        newList = list.map((item) => {
            return {
                id: item.id,
                name: item.name,
                selected: item.selected
            };
        });

        setCastData(newList);
    }, [list]);

    const onSetValues = (values) => {
        const updatedData = castData.map(
            (entry) => values?.find((updatedEntry) => entry?.id === updatedEntry?.id) ?? entry
        );
        setCastData(updatedData);
        onSetList(values.filter((item) => item.selected));
    };

    return (
        <DefaultSearchBox
            onSetValues={onSetValues}
            mutateList={null}
            errorList={null}
            searchKeys={HashtagItemSearchKey}
            id="hashtag"
            list={castData}
            isLoading={isLoading}
            errors={errors}
            disabled={disabled}
            noChoicesMessage={t('reports:general.hashtag_no_items')}>
            {({ isSubmitting, checkValue, choices, id, disabled }) => {
                return (
                    <HashtagItemCheckbox
                        allItems={choices}
                        isSubmitting={isSubmitting}
                        checkValue={checkValue}
                        id={id}
                        disabled={disabled}
                    />
                );
            }}
        </DefaultSearchBox>
    );
};

SearchBoxHashtag.propTypes = {
    onSetList: PropTypes.func.isRequired,
    list: PropTypes.array.isRequired,
    errors: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    isLoading: PropTypes.bool,
    disabled: PropTypes.bool
};

export default SearchBoxHashtag;
